<template>
  <navbar>
    <button class="navbar-togglerex" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <a class="navbar-brand" href="#"></a>
    <div class="menu_scrollbar hidden-md-down">
      <el-menu
        class="onlytitle"
        mode="horizontal"
        ref="headmenu"
        :default-active="activeindex"
        @select="handleSelect"
        text-color="#000">
        <el-menu-item v-for = "menu in menudata" :index= "menu.index" :key= "menu.key"  route="#">
          {{ menu.name }}
        </el-menu-item>
      </el-menu>
    </div>
    <el-popover
      placement="bottom-start"
      width="200"
      ref="menupop"
      v-model="showpop"
      trigger="click">
      <el-menu
        ref="headmenu"
        class="el-menu-vertical-demo"
        @select="handleSelect"
        text-color="#000">
        <el-menu-item v-for = "menu in menudata" :index= "menu.index" :key= "menu.key"  route="#">
          {{ menu.name }}
        </el-menu-item>
      </el-menu>
      <button slot="reference" class="navbar-togglerex hidden-lg-up" type="button" @click="rSidebarToggle">&#9776;</button>
    </el-popover>
    <ul class="nav navbar-nav ml-auto">
      <li class="nav-item hidden-md-down">
        <el-popover
          placement="bottom"
          width="400px"
          height="200px"
          trigger="click">
          <el-table :data="neworderinfo" style="font-size: 14px" height="200px">
            <el-table-column width="200" style="font-size: 14px" property="orderno" label="订单编号"></el-table-column>
            <el-table-column width="160" style="font-size: 14px" property="optime" label="下单时间"></el-table-column>
          </el-table>
          <a class="nav-link nav-pill" slot="reference" href="#"><i class="icon-bell"></i><span class="badge badge-pill badge-danger">{{newordercount}}</span></a>
        </el-popover>
        <!--
        <div style="visibility:hidden; display:none; "><audio ref="music"  >
          <source src="https://wyzb.oss-cn-beijing.aliyuncs.com/order/neworder.mp3" type="audio/mpeg">
        </audio>
        </div>
        -->
      </li>
      <!--
      <li class="nav-item hidden-md-down">
        <a class="nav-link nav-pill" href="#"><el-tooltip class="item" effect="dark" content="重置账号权限" placement="top-start">
          <i class="el-icon-refresh-right" v-on:click="resetqx"></i>
        </el-tooltip></a>
      </li>
      <li class="nav-item hidden-md-down">
        <a class="nav-link nav-pill" href="#"><el-tooltip class="item" effect="dark" content="定时上课提醒" placement="top-start">
          <i class="el-icon-alarm-clock" v-on:click="autotx"></i>
        </el-tooltip></a>
      </li>
      <li class="nav-item hidden-md-down">
        <a class="nav-link nav-pill" href="#"><el-tooltip class="item" effect="dark" content="管理员账号修改" placement="top-start">
          <i class="icon-key" v-on:click="changepwd"></i>
        </el-tooltip></a>
      </li>
      -->
      <li class="nav-item hidden-md-down">
        <img @click="showuserinfo" style="width: 42px;height: 42px; border-radius:50%" class="nav-link navbar-toggler aside-menu-toggler" :src="tximg" />
      </li>
    </ul>
    <el-dialog title="账号修改" :visible.sync="vis_admin_pwd">
      <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
        <el-form-item label="用户名">
          <el-input  v-model="ed_username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input  v-model="ed_pwd" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-button class="gibasebtn" @click="savepwd">更新信息</el-button>
      </el-form>
    </el-dialog>
    <el-dialog title="上课提醒" :visible.sync="vis_sktx">
      <el-tabs v-model="qdtab">
        <el-tab-pane :label="dtxinfo" name="txhylist">
          <el-table
            stripe
            :data="memberdata">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="openid"
              width = "200px"
              label="OpenID">
            </el-table-column>
            <el-table-column
              prop="usernick.String"
              width = "200px"
              label="会员昵称">
            </el-table-column>
            <el-table-column
              label="头像">
              <template slot-scope="scope">
                <div v-if="scope.row.userimg.Valid && scope.row.userimg.String !== ''">
                  <img :src="scope.row.userimg.String" class="avatarimg">
                </div>
                <div v-else>
                  {{scope.row.imgurl.String}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone.String"
              label="电话号码">
            </el-table-column>
            <el-table-column
              prop="name.String"
              label="姓名">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="提醒内容设置" name="txcontext">
          <el-form ref="form"  label-width="100px" label-position="left" >
            <el-form-item label="标题">
              <el-input  v-model="kq_title" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="课程名称">
              <el-input  v-model="kq_name" placeholder="请输入课程名称"></el-input>
            </el-form-item>
            <el-form-item label="课程时间">
              <el-input  v-model="kq_time" placeholder="请输入上课时间"></el-input>
            </el-form-item>
            <el-form-item label="课程地点">
              <el-input  v-model="kq_pos" placeholder="请输入上课地点"></el-input>
            </el-form-item>
            <el-form-item label="课前提醒">
              <el-input  v-model="kq_des" placeholder="请输入课前提醒内容"></el-input>
            </el-form-item>
            <el-button class="gibasebtn" @click="save_tmpmsg">保存模板消息</el-button>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="自动提醒设置" name="autxset">
          <el-row>
            <el-form ref="form"  label-width="100px" label-position="left" >
              <el-form-item label="具体时间">
                <el-time-select
                  placeholder="具体时间"
                  v-model="send_time"
                  :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30'
                }">
                </el-time-select>
              </el-form-item>
              <el-button class="gibasebtn" @click="save_timeset">保存设置</el-button> -->
            </el-form>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </navbar>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { EventBus } from '../../util/event-bus.js'
import navbar from './Navbar'
import { dropdown } from 'vue-strap'
Vue.prototype.$http = axios
var that
export default {
  name: 'header',
  data () {
    return {
      qdtab: 'txhylist',
      memberdata: [],
      dtxinfo: '',
      vis_tx: false,
      vis_sktx: false,
      activeindex: '',
      kq_title: '课前提醒',
      kq_name: '机器人培训课',
      kq_time: '',
      tximg: '',
      showpop: false,
      showmainmenu: false,
      kq_pos: '',
      kq_des: '',
      menudata: [],
      send_time: '',
      index: '',
      key: '',
      websock: null,
      wsUrl: 'wss://api.sqnetsoft.cn/websocket/ws',
      isConnection: false,
      isErrorCallBack: false,
      lockReconnect: false,
      vis_admin_pwd: false,
      ed_username: '',
      sel_openids: [],
      ed_pwd: '',
      ping: false,
      newordercount: 0,
      readyState: false,
      neworderinfo: [],
      khid: ''
    }
  },
  created () {
    // this.initWebSocket(this.wsUrl)
  },
  destroyed () {
    // this.websocketclose()
  },
  mounted: function () {
    that = this
    if (getCookie('accesstoken') === '' || getCookie('accesstoken') === null) {
      that.$options.methods.getaccesstoken()
    } else {
    }
    that.menudata = []
    if (localStorage.getItem('userimg') === null || localStorage.getItem('userimg') === '') {
      this.tximg = 'https://sqpro.oss-cn-beijing.aliyuncs.com/admin/img/tx.jpg'
    }
    EventBus.$on('reloadmenu', () => {
      var data = JSON.parse(localStorage.getItem('models'))
      that.menudata = []
      for (var j = 0; j < data[0].Children.length; j++) {
        var subdata = {'index': data[0].Children[j].Id, 'key': data[0].Children[j].Id, 'name': data[0].Children[j].Name}
        that.menudata.push(subdata)
      }
    })

    /*
    EventBus.$emit('mainmenuchange', {
      mainmenuid: key
    })
    localStorage.setItem('SelectMainMenuID',key)
    */
    var data = JSON.parse(localStorage.getItem('models'))
    for (var j = 0; j < data[0].Children.length; j++) {
      var subdata = {'index': data[0].Children[j].Id, 'key': data[0].Children[j].Id, 'name': data[0].Children[j].Name}
      that.menudata.push(subdata)
    }
    if (localStorage.getItem('SelectMainMenuID') !== undefined && localStorage.getItem('SelectMainMenuID') !== null && localStorage.getItem('SelectMainMenuID') !== '') {
      window.console.log('缓存中读取菜单ID')
      this.activeindex = localStorage.getItem('SelectMainMenuID')
    }
    /*
    that.kq_time = getNowFormatDate()
    var qstr = 'sale_cus_id = ' + this.khid + ' and ifnew=0 and state_id =2'
    that.$http({
      url: 'https://api.sqnetsoft.cn/order/goi',
      method: 'post',
      data: {
        whereinfo: {String: qstr, Valid: true},
        sorinfo: {String: ' order by op_time desc', Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log('*****************初始化分类数据******************')
        if (res.data.success) {
          console.log('已完成分类数据初始化')
          that.neworderinfo = JSON.parse(res.data.data)
          that.newordercount = that.neworderinfo.length
        } else {
          console.log('获取分类数据失败')
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
    this.dtxinfo = '待提醒会员列表(' + getNowFormatDate() + ')'
    this.$options.methods.gettxmemberlist()
    */
    /*
    setInterval(function () {
      console.log(getNewTime())
      if (getNewTime().toString().trim() === localStorage.getItem('sendtime').toString().trim()) {
        var requestlist = []
        for (var i = 0; i < that.sel_openids.length; i++) {
          var request = that.$http({
            url: 'https://api.sqnetsoft.cn/wx/sgtm',
            method: 'post',
            data: {
              accesstoken: getCookie('accesstoken'),
              touser: that.sel_openids[i],
              tempid: 'UFEnvZPBYP19EoXC9EhIOJgPKctH_R1JDRbGQRsldNM',
              url: 'http://www.baidu.com?openid=' + that.sel_openids[i],
              data: {
                first: {value: localStorage.getItem('kqtitle'), color: '#FF0000'},
                keyword1: {value: localStorage.getItem('kqname')},
                keyword2: {value: getNowFormatDate()},
                keyword3: {value: localStorage.getItem('kqpos')},
                remark: {value: localStorage.getItem('kqdes')}
              },
              color: '#000000'
            },
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              if (res.data.success) {
                // 把相关数据缓存到本地
                window.console.log(res.data.data)
              }
            })
            .catch(function (error) {
              window.console.log(error)
            })
          requestlist.push(request)
        }
        console.log(requestlist)
        axios.all(requestlist)
      }
    }, 1000 * 60)
     -->
     */
  },
  components: {
    navbar,
    dropdown
  },
  methods: {
    showuserinfo () {
      this.$router.push({path: 'UserBaseInfo'})
    },
    resetqx () {
      localStorage.removeItem('addmodels')
      var tmpdata = '[{"Id":"318","AppID":"5","Name":"新用户配置","ParentID":"-1","Level":0,"HasChild":1,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"319","AppID":"5","Name":"我的","ParentID":"318","Level":1,"HasChild":1,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"324","AppID":"5","Name":"用户资料","ParentID":"319","Level":2,"HasChild":1,"Icon":{"String":"fa fa-indent","Valid":true},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"345","AppID":"5","Name":"账号信息","ParentID":"324","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"UserBaseInfo","Valid":true},"Leaf":"true","Children":null},{"Id":"346","AppID":"5","Name":"账号升级","ParentID":"324","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"CompleteInfo","Valid":true},"Leaf":"true","Children":null}]},{"Id":"328","AppID":"5","Name":"系统配置","ParentID":"319","Level":2,"HasChild":1,"Icon":{"String":"fa fa-indent","Valid":true},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"348","AppID":"5","Name":"短信配置","ParentID":"328","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"SMSSet","Valid":true},"Leaf":"true","Children":null},{"Id":"349","AppID":"5","Name":"支付配置","ParentID":"328","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"PaySet","Valid":true},"Leaf":"true","Children":null}]},{"Id":"329","AppID":"5","Name":"功能扩展","ParentID":"319","Level":2,"HasChild":1,"Icon":{"String":"fa fa-indent","Valid":true},"ModelUrl":{"String":"","Valid":false},"Leaf":"false","Children":[{"Id":"351","AppID":"5","Name":"功能管理","ParentID":"329","Level":3,"HasChild":0,"Icon":{"String":"","Valid":false},"ModelUrl":{"String":"AddModel","Valid":true},"Leaf":"true","Children":null}]}]}]}]'
      var updatas = []
      var updata = {
        userid: parseInt(localStorage.getItem('accountid')),
        models: tmpdata
      }
      updatas.push(updata)
      that.$http({
        url: 'http://api.sqnetsoft.cn/permission/papu',
        method: 'post',
        data: updatas,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success) {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      var delbuyqx = ' accountid = ' + localStorage.getItem('accountid')
      that.$http({
        url: 'http://api.sqnetsoft.cn/permission/dbmb',
        method: 'post',
        data: {
          whereinfo: {String: delbuyqx, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success) {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    getaccesstoken: function () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/wx/getaccesstoken',
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            setCookie('accesstoken', res.data.data, 7200)
            // 把相关数据缓存到本地
          }
        })
        .catch(function (error) {
          window.console.log(error)
        })
    },
    gettxmemberlist () {
      var tmpdata = new Date()
      var week = tmpdata.getDay()
      console.log(week)
      if (week === 0) {
        week = 7
      }
      var wstr = ' weekid = ' + week
      // var wstr = ' weekid = 6'
      that.$http({
        url: 'https://api.sqnetsoft.cn/class/qbcs',
        method: 'post',
        data: {
          whereinfo: {String: wstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            if (res.data.data !== '[]') {
              var tmpclassmember = JSON.parse(res.data.data)
              that.classmember = []
              for (var i = 0; i < tmpclassmember.length; i++) {
                that.classmember.push("'" + tmpclassmember[i].userphone + "'")
              }
              var cstr = 'phone in (' + that.classmember + ')'
              that.$http({
                url: 'https://api.sqnetsoft.cn/member/gbuw',
                method: 'post',
                data: {
                  whereinfo: {String: cstr, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    console.log(JSON.parse(res.data.data))
                    if (res.data.data!== '[]') {
                      console.log(that.sel_openids)
                      that.sel_openids = []
                      that.memberdata = JSON.parse(res.data.data)
                      for (var i = 0; i < that.memberdata.length; i++) {
                        that.sel_openids.push(that.memberdata[i].openid)
                      }
                    } else {
                      that.memberdata = []
                      that.sel_openids = []
                    }
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    changepwd () {
      that.vis_admin_pwd = true
      var qstr = 'cus_user_id = 1'
      that.$http({
        url: 'https://api.sqnetsoft.cn/account/getaccountlist',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log('已成功用户数据')
            var curdata = JSON.parse(res.data.data)
            console.log(curdata)
            that.ed_username = curdata.username
            that.ed_pwd = curdata.password
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    savepwd () {
      var adata = {
        id: {Int64: parseInt(1), Valid: true},
        username: this.ed_username,
        password: this.ed_pwd,
        cususerid: '1'
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/account/aaubai',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '变更成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    save_tmpmsg () {
      localStorage.setItem('kqtitle', this.kq_title)
      localStorage.setItem('kqname', this.kq_name)
      localStorage.setItem('kqpos', this.kq_pos)
      localStorage.setItem('kqdes', this.kq_des)
      that.$message({
        type: 'success',
        message: '设置完毕!'
      })
    },
    save_timeset () {
      localStorage.setItem('sendtime', this.send_time)
      that.$message({
        type: 'success',
        message: '设置完毕!'
      })
    },
    autotx () {
      this.vis_sktx = true
      this.kq_title = localStorage.getItem('kqtitle')
      this.kq_name = localStorage.getItem('kqname')
      this.kq_time = getNowFormatDate()
      this.kq_pos = localStorage.getItem('kqpos')
      this.kq_des = localStorage.getItem('kqdes')
      this.send_time = localStorage.getItem('sendtime')
    },
    click () {
      // do nothing
    },
    rSidebarToggle () {
      this.showmainmenu = true
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleSelect (key, keyPath) {
      console.log('已打开' + key)
      EventBus.$emit('mainmenuchange', {
        mainmenuid: key
      })
      this.showpop = false
      localStorage.setItem('SelectMainMenuID',key)
      setCookie('SelectMainMenuID', key, 1)
    }
    /*
    initWebSocket (url) {
      this.websock = new WebSocket(url)
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onmessage = this.websocketonmessage
      this.websock.onclose = this.websocketclose
    },

    websocketonopen () {
      console.log('WebSocket连接成功')
      this.isConnection = true
      this.isErrorCallBack = false
      this.readyState = true
    },
    websocketonerror (e) {
      console.log('WebSocket连接发生错误')
      this.reconnect(this.wsUrl)
    },
    websocketonmessage (e) {
      console.log(e)
      console.log(this)
      var that = this
      this.$refs.music.play()
      var qstr = 'sale_cus_id = ' + this.khid + ' and ifnew=0 and state_id=2'
      that.$http({
        url: 'https://api.sqnetsoft.cn/order/goi',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true},
          sorinfo: {String: ' order by op_time desc', Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('*****************初始化分类数据******************')
          if (res.data.success) {
            console.log('已完成分类数据初始化')
            that.neworderinfo = JSON.parse(res.data.data)
            that.newordercount = that.neworderinfo.length
          } else {
            console.log('获取分类数据失败')
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },

    websocketsend (agentData) {
      this.websock.send(agentData)
    },

    websocketclose (e) {
      console.log('connection closed ("' + e.code + '")')
      this.reconnect(this.wsUrl)
    },
    reconnect (url) {
      this.initWebSocket(url)
    },
    send (cmd) {
      this.websock.send('heart')
    },
    heartCheck () {
      let that = this
      this.heartCheck = {
        timeout: 10000, // 10秒
        timeoutObj: null,
        serverTimeoutObj: null,
        reset: function () {
          clearTimeout(this.timeoutObj)
          clearTimeout(this.serverTimeoutObj)
        },
        start: function () {
          this.reset()
          let self = this
          this.timeoutObj = setTimeout(function () {
            // 这里发送一个心跳，后端收到后，返回一个心跳消息
            // onmessage拿到返回的心跳就说明连接正常
            that.send('{"event": "ping"}')
            self.serverTimeoutObj = setTimeout(function () { // 如果超过一定时间还没重置，说明后端主动断开了
              // 如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
              that.websock.close()
            }, self.timeout)
          }, this.timeout)
        }
      }
    }
     */
  }
}
function setCookie (name, value, days) {
  var d = new Date()
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days)
  window.document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString()
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
/*
function getNewTime () {
  var date = new Date()
  var seperator2 = ':'
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var hours = date.getHours()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  var minutes = date.getMinutes()
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  var seconds = date.getSeconds()
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  var currentdate = hours + seperator2 + minutes
  return currentdate
}
*/
function getNowFormatDate () {
  var date = new Date()
  var seperator1 = '-'
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  var hours = date.getHours()
  if (hours >= 0 && hours <= 9) {
    hours = '0' + hours
  }
  var minutes = date.getMinutes()
  if (minutes >= 0 && minutes <= 9) {
    minutes = '0' + minutes
  }
  var seconds = date.getSeconds()
  if (seconds >= 0 && seconds <= 9) {
    seconds = '0' + seconds
  }
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
  return currentdate
}
</script>
<style lang="css">
  .menudiv {
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
  }
  .navbar-togglerex {
    padding: 1rem 1.5rem;
    font-size: 1.25rem;
    line-height: 1.25;
    background: transparent;
    border: 0px;
  }
  /**左侧顶部Logo位置 **/
  header.navbar .navbar-brand {
    display: inline-block;
    width: 250px;
    height: 60px;
    padding: 0.5rem 1rem;
    margin-right: 0;
    background-color: transparent;
    background-image: url(../../../static/img/sqlogo3.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 140px auto;
    border-bottom: 0px solid #1985ac;
  }
  .menu_scrollbar {
    overflow: inherit;
    background-color: #00a67c;
  }
  .onlytitle {
    overflow: hidden;
    max-height: 60px;
  }
  .navbar-togglerex:focus, .navbar-togglerex:hover {
    text-decoration: none; }
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue